//品类指数定义

import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 价格类型
 */
class PriceType extends UltMeta {
    UP_BOAT = new Meta(1, "上船价");
    TOUCH_PORT = new Meta(2, "靠港价");
}

export const PRICE_TYPE = new PriceType();

/**
 * 查询方式
 */
class QueryMode extends UltMeta {
    SEVEN_DAYS = new Meta(1, "近七天");
    MONTH = new Meta(2, "近一月");
    YEAR = new Meta(3, "近一年");
}

export const QUERY_MODE = new QueryMode();

/**
 * 首页指数模块tab
 */
class StageType extends UltMeta {
    DAY_STAGE = new Meta(1, "日水位");
    WEEK_STAGE = new Meta(2, "周水位");
}

export const STAGE_TYPE = new StageType();
